export default __webpack_public_path__ + "static/media/04.1c7fc3f9.png";